import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const Transparenz = () => (
  <Layout>
    <SEOHead
      title="Transparenz | heilys.info – Affiliate-Hinweise & Unabhängigkeit"
      description="Transparente Hinweise zu Partnerlinks, Finanzierung und unabhängiger Ausrichtung von heilys.info – inkl. Bedingungen zum Rabattcode LONGEVITY."
      canonical="https://heilys.info/transparenz"
      ogImageAlt="Transparenzhinweise von heilys.info – Affiliate-Disclosure"
      noIndex={false}
      schemaJson={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: "https://heilys.info/" },
          { "@type": "ListItem", position: 2, name: "Transparenz", item: "https://heilys.info/transparenz" },
        ],
      }}
    />
    <div className="container py-16 md:py-24">
      <div className="mx-auto max-w-2xl">
        <nav aria-label="Breadcrumb" className="text-xs text-muted-foreground">
          <Link to="/" className="hover:text-foreground">Startseite</Link>
          <span className="mx-2">›</span>
          <span className="text-foreground">Transparenz</span>
        </nav>
        <h1 className="mt-4 font-display text-3xl font-bold text-foreground">Transparenz</h1>

        <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
          Uns ist wichtig, dass du genau weißt, wer hinter heilys.info steht, wie sich diese Seite finanziert und wie unsere Inhalte entstehen. Auf dieser Seite findest du alle relevanten Informationen dazu.
        </p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Was ist heilys.info?</h2>
            <p className="mt-2">
              heilys.info ist eine unabhängige Informationsseite rund um die Produkte der Marke heilys. Wir sind <strong className="text-foreground">nicht</strong> der offizielle heilys Shop und stehen in keiner direkten geschäftlichen oder organisatorischen Verbindung zum Unternehmen heilys. Unser Ziel ist es, Interessierten eine schnelle, übersichtliche Orientierung zum Produktsortiment zu bieten und den aktuell verfügbaren Rabattcode LONGEVITY leicht zugänglich zu machen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Wie finanziert sich diese Seite?</h2>
            <p className="mt-2">
              heilys.info enthält sogenannte Affiliate-Links (Partnerlinks). Das bedeutet: Wenn du über einen Link auf dieser Seite zum heilys Shop gelangst und dort ein Produkt kaufst, erhalten wir eine kleine Provision vom Anbieter. Für dich ändert sich am Preis nichts – du zahlst keinen Cent mehr als bei einem Direktbesuch im Shop. Diese Provisionen ermöglichen es uns, die Seite zu betreiben, Inhalte zu pflegen und die Informationen aktuell zu halten.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Beeinflusst das die Inhalte?</h2>
            <p className="mt-2">
              Nein. Unsere Inhalte sind redaktionell unabhängig. Wir bemühen uns um eine sachliche, neutrale Darstellung der verschiedenen Produktkategorien und vermeiden bewusst übertriebene Werbeversprechen, medizinische Heilaussagen oder erfundene Testergebnisse. Wenn wir zu einem Produkt oder einer Kategorie keine verlässlichen Informationen haben, lassen wir die Darstellung lieber offen, anstatt spekulative Angaben zu machen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Woher stammen die Informationen?</h2>
            <p className="mt-2">
              Die auf dieser Seite dargestellten Informationen basieren auf öffentlich zugänglichen Herstellerangaben, den Produktbeschreibungen im offiziellen heilys Shop sowie eigener Recherche. Wir erheben keinen Anspruch auf Vollständigkeit oder dauerhafte Aktualität. Produktdetails, Preise und Verfügbarkeiten können sich jederzeit ändern. Wir empfehlen daher, vor einem Kauf immer die aktuellen Angaben direkt im heilys Shop zu prüfen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Rabattcode LONGEVITY</h2>
            <p className="mt-2">
              Der auf dieser Seite beworbene Rabattcode <strong className="text-foreground">LONGEVITY</strong> bietet nach aktuellem Stand 5 % Rabatt auf das heilys Sortiment. Die Gültigkeit, die genauen Konditionen und die Kombinierbarkeit mit anderen Aktionen können sich jederzeit ändern, da der Code vom Anbieter heilys bereitgestellt wird und wir keinen Einfluss auf dessen Bedingungen haben. Bitte prüfe die aktuellen Bedingungen direkt im Checkout des heilys Shops.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Medizinischer Hinweis</h2>
            <p className="mt-2">
              Die Inhalte auf heilys.info dienen ausschließlich der allgemeinen Information und Orientierung. Sie ersetzen keine medizinische Beratung, Diagnose oder Behandlung durch qualifiziertes Fachpersonal. Wir machen keine medizinischen Heilversprechen und empfehlen, bei gesundheitlichen Fragen oder Beschwerden immer einen Arzt oder eine Ärztin zu konsultieren. Aussagen zu möglichen Anwendungsbereichen der Produkte sind allgemeiner Natur und stellen keine Gesundheitsberatung dar.
            </p>
          </section>

          <p className="mt-8 text-sm text-muted-foreground">
            Zurück zur{" "}
            <Link to="/" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
              heilys Rabattcode Übersicht
            </Link>
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default Transparenz;
